import { U21Form, U21Modal } from 'app/shared/u21-ui/components';
import { IconBookmark } from '@u21/tabler-icons';

import {
  Filter,
  SavedFilter,
  SaveFilterFormValues,
} from 'app/modules/filters/models';
import { useUpdateSavedFilter } from 'app/modules/filters/queries/useUpdateSavedFilter';
import { SaveFilterFormContent } from 'app/modules/filters/components/SaveFilterFormContent';
import { SHARING_PRIVATE, SHARING_TEAMS } from 'app/modules/filters/constants';

const FORM_ID = 'edit-saved-filter-form';

interface Props {
  filters: Filter[];
  onClose: () => void;
  onUpdated?: (savedFilter: SavedFilter) => void;
  open: boolean;
  savedFilter: SavedFilter;
}

export const EditSavedFilterModal = ({
  filters,
  onClose,
  onUpdated,
  open,
  savedFilter,
}: Props) => {
  const { isPending, mutateAsync: updateSavedFilter } = useUpdateSavedFilter();

  return (
    <U21Modal
      title="Update Saved Filter"
      titleIcon={<IconBookmark />}
      open={open}
      onClose={onClose}
      actionButtonProps={{
        children: 'Update Filter',
        type: 'submit',
        form: FORM_ID,
        loading: isPending,
      }}
    >
      <U21Form<SaveFilterFormValues>
        id={FORM_ID}
        prompt={false}
        initialValues={{
          title: savedFilter.title,
          description: savedFilter.description ?? '',
          sharing:
            savedFilter.shared_team_ids.length > 0
              ? SHARING_TEAMS
              : SHARING_PRIVATE,
          team_ids: savedFilter.shared_team_ids,
        }}
        onSubmit={async (values) => {
          try {
            const updated = await updateSavedFilter({
              id: savedFilter.id,
              title: values.title,
              // default description to empty string so its clearable
              description: values.description ?? '',
              filters,
              team_ids: values.sharing === SHARING_TEAMS ? values.team_ids : [],
            });
            onUpdated?.(updated);
            onClose();
          } catch {}
        }}
      >
        <SaveFilterFormContent />
      </U21Form>
    </U21Modal>
  );
};
